module.exports = __webpack_public_path__ + "static/media/file.c6511f0b.svg";